import { classNames } from 'primereact/utils';

export const ChipTailwindThemes = {
  chip: {
    root: {
      className: classNames(
        'inline-flex items-center',
        'py-0.75 px-1.75',
        'border border-fletchers-green-500 rounded-sm bg-white',
        'transition-colors duration-200 appearance-none',
        'hover:bg-fletchers-gray-50',
      ),
    },
    label: 'text-xs text-fletchers-green-500 cursor-default',
    icon: 'leading-6 mr-1',
    image: {
      className: classNames('size-9 mx-1', 'rounded-full'),
    },
    removeIcon: {
      className: classNames(
        'ml-1 cursor-pointer outline-transparent',
        'transition duration-200 ease-in-out',
        'focus-visible:outline-fletchers-green-500',
      ),
    },
  },
};
